// extracted by mini-css-extract-plugin
var _1 = "Tags-moduletooltipContent__StzhX";
export { _1 as "tooltipContent" }
